import { useState,useEffect } from "react"
import { useToast,Box, SkeletonCircle,SkeletonText,Divider,Button,Spacer,Stack,
  Tabs, TabList, TabPanels, Tab, TabPanel,InputGroup,Input,InputLeftElement,
  IconButton,Tooltip
 } from "@chakra-ui/react";
import { MdOutlineReceiptLong } from "react-icons/md";
import { RiFileExcel2Fill } from "react-icons/ri";
import { PiCowBold } from "react-icons/pi";
import { SearchIcon } from "@chakra-ui/icons";
import { PopisGovedaSelect } from "../popisgoveda/PopisGovedaSelect";
import { getPopisGovedaZaSpecifikaciju } from "../../util/apiMRgg";
import { getPopisGovedoNaSpecifikacijiXlsx } from "../../util/apiSpecifikacija";
import { getKnjigeShort } from "../../util/apiKnjiga";
import { getPojedinacnaGrlaForSpecifikacija, getOdabranaGovedaZaSpecifikaciju,getSpecifikacija } from "../../util/apiSpecifikacija";
import { SpecifikacijaOdabranaGovedaTable } from "./SpecifikacijaOdabranaGovedaTable";
import { GovedaListForSpecifikacija } from "../govedo/GovedaListForSpecifikacija";
import { SpecifikacijaOdlazakDetails } from "./SpecifikacijaOdlazakDetails";
import { loggedOper as lp } from "../../util/grunt";


export const SpecifikacijaItem=({specifikacijaid=0,size='xs',onDataCanBeSaved,onChange,readonly=false,organizatori=[]})=>{
    const [data,setData]=useState([])
    

    const [specifikacija,setSpecifikacija]=useState({odlazakdetails:{
      specid:specifikacijaid,kamion_br:'',migracija_datum:new Date().toISOString().split('T')[0],migracija_ijr:new Date().toISOString().split('T')[0],migrdok_tip_id:1,dokument_broj:'',
      migracija_posjednik_id:-1,jibg:'',uktezina:0,migracija_tip:"",
        migracija_posjednik_naziv:"",migracija_posjednik_mjesto:"",migracija_posjednik_drzava:"",migracija_posjednik_sifra:"",provedena:false,
        organizator_id:organizatori.length===0?0:organizatori[0].organizator_subjekt_id
    },popisi:[],goveda:[],filterval:""})
    //govedo_id,govedo_migracija_id,spol,pasmina,knjiga,knjiga_id,zivbr,dnautovu
    const [dataisloading,setDataIsLoading]=useState(true);
    const [dataknjigeisloading,setDataKnjigeIsLoading]=useState(true);
    const [punigovedaizpopisa,setPuniGovedaIzPopisa]=useState(false);
    const [pojedinacnagoveda,setPojedinacnaGoveda]=useState([]);
    const [pojedinacnagovedaselected,setPojedinacnaGovedaSelected]=useState([]);
    const [errmsgdata,setErrMsgData]=useState("");
    const [dodajpopis,setDodajPopis]=useState(false);
    const [dodajpojedinacnagoveda,setDodajPojedinacnaGoveda]=useState(false);
    const [togglegetpojedinacnagoveda,setToggleGetPojedinacnaGoveda]=useState(false);
    const [knjige,setKnjige]=useState([]);
    const [selectedknjigaid,setSelectedKnjigaId]=useState(0);
    const [isGeneratingExcel,setIsGeneratingExcel]=useState(false);
    
    const toast=useToast()

    useEffect(() => {
      const getData=async()=>{
        try {
          setDataIsLoading(true);
          const res=await getOdabranaGovedaZaSpecifikaciju(pojedinacnagovedaselected,null)
          if (res.status===200) {
            const _ar=res.res.map((item)=>{return {...item,popis_rgg_id:0,popis_datum:'1900-1-1',popis_operater:'',popis_naziv:''}})
            const _ar2=specifikacija.goveda.filter((item)=>item.popis_rgg_id!==0);
            const _s={...specifikacija};
            _s.goveda=[];
            _s.goveda=_ar.concat(_ar2);
            onChange(_s);
            setSpecifikacija(_s);
            setPojedinacnaGovedaSelected([])
          }
        } catch (error) {
            setErrMsgData(error.message);
        } finally {
          setDataIsLoading(false);
         
        }
      }

      
        if (pojedinacnagovedaselected.length!==0) {
          getData();
        } else {
          const _ar=specifikacija.goveda.filter((item)=>item.popis_rgg_id!==0);
          const _s={...specifikacija};
          _s.goveda=[];
          _s.goveda=_ar;
          if (!dataisloading) {
            onChange(_s);  
          }
          
          setSpecifikacija(_s);
        
      }
      
    }, [togglegetpojedinacnagoveda])
    

    useEffect(() => {
      const getData=async()=>{
        try {
          //setDataGovedaIsLoading(true);
          const res=await getPojedinacnaGrlaForSpecifikacija(selectedknjigaid)
          if (res.status===200) {
            setPojedinacnaGoveda(res.res);
          } else {
            setErrMsgData(res.message);
          }
        } catch (error) {
          setErrMsgData(error.message);
        } finally {
         // setDataGovedaIsLoading(false);
          setSelectedKnjigaId(0);
        }
      }
      if (selectedknjigaid!==0) {
        getData();
      }
    }, [selectedknjigaid])
    

    useEffect(() => {//punjenje podataka ako se radi o ispravku specifikacije
      const getData=async ()=>{
        try {
          const resGovPojed=await getOdabranaGovedaZaSpecifikaciju(null,specifikacijaid);
          const _argov1=resGovPojed.res.map((item)=>{return {...item,popis_rgg_id:0,popis_datum:'1900-1-1',popis_operater:'',popis_naziv:''}});

          const resGovPopis=await getPopisGovedaZaSpecifikaciju(null,specifikacijaid);
          const _argov2=resGovPopis.res;
          //goveda
          
          
          const _goveda=_argov1.concat(_argov2);
          //popisi
          const _popisi=[];
          for (const _p of resGovPopis.res) {
            const _idx=_popisi.findIndex((item)=>item===_p.popis_rgg_id);
            if (_idx===-1) {
              _popisi.push(_p.popis_rgg_id)
            }
          }
          //odlazakdetails
          const resSpecData=await getSpecifikacija(specifikacijaid)
          const _odlazakdetails={...specifikacija.odlazakdetails};
          if (resSpecData.res.length===1) {
            _odlazakdetails.kamion_br=resSpecData.res[0].kamion_br;  
            _odlazakdetails.migracija_datum=new Date(resSpecData.res[0].migracija_datum).toISOString().split('T')[0];  
            _odlazakdetails.migracija_ijr=new Date(resSpecData.res[0].migracija_ijr).toISOString().split('T')[0];
            _odlazakdetails.migrdok_tip_id=resSpecData.res[0].migrdok_tip_id;
            _odlazakdetails.dokument_broj=resSpecData.res[0].dokument_broj;
            _odlazakdetails.migracija_posjednik_id=resSpecData.res[0].migracija_posjednik_id;
            _odlazakdetails.jibg=resSpecData.res[0].jibg;
            _odlazakdetails.uktezina=resSpecData.res[0].tezina;
            _odlazakdetails.migracija_tip=resSpecData.res[0].migracija_tip;
            _odlazakdetails.migracija_posjednik_naziv=resSpecData.res[0].migracija_posjednik_naziv;
            _odlazakdetails.migracija_posjednik_mjesto=resSpecData.res[0].migracija_posjednik_mjesto;
            _odlazakdetails.migracija_posjednik_sifra=resSpecData.res[0].migracija_posjednik_sifra;
            _odlazakdetails.migracija_posjednik_drzava=resSpecData.res[0].migracija_posjednik_drzava;
            _odlazakdetails.provedena=resSpecData.res[0].provedena;
            _odlazakdetails.organizator_id=resSpecData.res[0].organizator_subjekt_id;
            
          }
          //
          setSpecifikacija({...specifikacija,odlazakdetails:_odlazakdetails,goveda:_goveda,popisi:_popisi});
          
        } catch (error) {
            setErrMsgData(error.message);
        } finally {
            setDataIsLoading(false);
        }
      }
      if (specifikacijaid!==0) {
        getData();
      } else {
        setDataIsLoading(false);
      }
    }, [specifikacijaid])

    useEffect(() => {//inicijalno dohvacanje knjiga
      const getKnjige=async()=>{
        try {
          const _knj=await getKnjigeShort();
            if (_knj.status===200) {
              setKnjige(_knj.res)
            } else {
              setErrMsgData(_knj.message);
            }
        } catch (error) {
          setErrMsgData(error.message);
        } finally {
          setDataKnjigeIsLoading(false);
        }
      }
      getKnjige();
    }, [])
    

    useEffect(() => {//dodavanje goveda koji su specificirani na popisu
      const getData=async ()=>{
        try {
          setDataIsLoading(true);
          const res=await getPopisGovedaZaSpecifikaciju(specifikacija.popisi,null);
          const _gov=specifikacija.goveda.filter((item)=>item.popis_rgg_id===0);
          const _r=_gov.concat(res.res);
          const _s={...specifikacija};
          _s.goveda=[];
          _s.goveda=_r
          onChange(_s);
          setSpecifikacija(_s);
        } catch (error) {
          setErrMsgData(error.message);
        } finally {
          setDataIsLoading(false);
          setPuniGovedaIzPopisa(false)
        }
      }
      if (punigovedaizpopisa) {
        
          if (specifikacija.popisi.length!==0 ) {
            getData();  
          } else {
            clearPopisData();
          }  
          
      }
      
      
      
    }, [punigovedaizpopisa])
    
    const clearPopisData=()=>{
        const _s={...specifikacija};
        _s.goveda=[];
        const _r=specifikacija.goveda.filter((item)=>item.popis_rgg_id===0);
        _s.goveda=_r;
        if (!dataisloading) {
          onChange(_s);  
        }
        
        setSpecifikacija(_s);  
        setPuniGovedaIzPopisa(false);
      
    }
    const setSelectedPopisi=(popisiarr)=>{
        
      setSpecifikacija({...specifikacija,popisi:popisiarr})
      setDodajPopis(false);
      onDataCanBeSaved(true);
      setPuniGovedaIzPopisa(true);
    }
    const getSkeleton=()=>{
        if (dataisloading || dataknjigeisloading ) {
          return (
            <Box display={'flex'} flexDir={'column'} flex={1}>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={15} spacing='4' skeletonHeight='4' />
            </Box>
          )
        }
      }
      const showErr=()=>{
        if (errmsgdata!=="") {
            toast({
              title:"RGG",
              status:"error",
              description:errmsgdata,
              isClosable:true,
              duration:2500,
              position:"top-right",
          });
          setErrMsgData("")
        }
      }

      const handleChangeFilter=(e)=>{
        let _f=e.target.value.toUpperCase().replaceAll("_",".").replaceAll("*",".*");;
        const _rgxstr="^.*" + _f+"$"; 
        const _r=new RegExp(_rgxstr);
        let _test=false;
        
        const _ar=[...specifikacija.goveda]
        
        _ar.forEach((gov)=>{
          _test=_r.test(gov.zivbr) || _f==="";
          gov.filtered=_test;
          

        })
        
           //setSpecifikacija({...specifikacija,filterval:e.target.value.toUpperCase()})
           setSpecifikacija({...specifikacija,goveda:_ar,filterval:e.target.value.toUpperCase()})
      }

      const getSearchBox=()=>{
        return (
            <>
                <InputGroup size={'xs'} w={'30rem'} alignContent={'center'} >
                  <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                  <Input focusBorderColor='grunt2.400' value={specifikacija.filterval} onChange={handleChangeFilter}  variant={'outline'} placeholder={'*=više znakova / _ =jedan znak'} w={'30rem'}></Input>
                </InputGroup>
                
            </>
        )
    }

    const getExcelReport=async ()=>{
      if (specifikacija.odlazakdetails.specid>0) {
        
      
      try {
        setIsGeneratingExcel(true)
          const _res=await getPopisGovedoNaSpecifikacijiXlsx(specifikacija.odlazakdetails.specid)
          const blob = new Blob([_res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                    
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = "spec_goveda.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
      } catch (error) {
        setErrMsgData(error.message);
      } finally {
        setIsGeneratingExcel(false);
      }
    }
  }

      const getMenu=()=>{
        if (!dataisloading && !dataknjigeisloading ) {
        return (
          <Box display={'flex'} flexDirection={'row'} h={'2rem'} mt={'0.5rem'} mb={'0.5rem'} alignItems={'center'}>
              {getSearchBox()}
              <Spacer/>
              <Stack direction={'row'} spacing={'2rem'}>
                <Button isDisabled={dodajpopis || dodajpojedinacnagoveda || readonly} rightIcon={<MdOutlineReceiptLong/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={()=>{setDodajPopis(true);onDataCanBeSaved(false)}}>Popisi</Button> 
                <Button isDisabled={dodajpopis || dodajpojedinacnagoveda || readonly} rightIcon={<PiCowBold/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={()=>{setDodajPojedinacnaGoveda(true);onDataCanBeSaved(false)}}>Goveda</Button> 
                <Spacer/>
                <Tooltip label={'Izvezi u Excel'} placement={'left-start'}>
                    <IconButton isLoading={isGeneratingExcel} isDisabled={specifikacija.odlazakdetails.specid===0} onClick={getExcelReport}  ml={'1rem'} aria-label='Ispis' variant={'outline'} colorScheme={'grunt2'} icon={<RiFileExcel2Fill/>} size={'xs'}/>
                </Tooltip>
              </Stack>
          </Box>
        )
      }
      }
      
      const showDodajPopis=()=>{
        return (
          <Box display={'flex'} flexDirection={'column'} flex={1} overflowY={'auto'} className="noscroll">
            <PopisGovedaSelect specifikacije={[specifikacijaid]} selectedRggId={specifikacija.popisi} onClose={()=>{setDodajPopis(false);onDataCanBeSaved(true)}} onSelect={setSelectedPopisi}/>   
          </Box>
        )
      }

      
      const getPojedinacnaGovedaId=()=>{
        const _res=specifikacija.goveda.filter((item)=>item.popis_rgg_id===0);
        const _r=_res.map((item)=>item.govedo_id);
        return _r;
      }
      const handleRemoveGovedo=(_govid)=>{
        const _g=[...specifikacija.goveda]
        const _idx=_g.findIndex((item)=>item.govedo_id===_govid);
        _g.splice(_idx,1);
        if (_idx!==-1) {
          setSpecifikacija({...specifikacija,goveda:_g});
        }
      }
      const getSelectedGoveda=()=>{
          return (
            
              <Box display={'flex'} flexDir={'column'} flex={1}>
                <SpecifikacijaOdabranaGovedaTable readonly={readonly} onRemoveGovedo={handleRemoveGovedo} goveda={specifikacija.goveda.filter((item)=>item.filtered===undefined || item.filtered)}/>
              </Box>
         
          )
      }

      
      const handlePojedinacnoGovedoSelected=(govidarr)=>{

        setPojedinacnaGovedaSelected(govidarr)
        
      }
      const handleFinishSelectPojedinacnaGoveda=()=>{
        setDodajPojedinacnaGoveda(false);
        onDataCanBeSaved(true);
        setToggleGetPojedinacnaGoveda(!togglegetpojedinacnagoveda);
        
        setPojedinacnaGoveda([]);
      }
      const handleCloseSelectPojedinacnoGovedo=()=>{
        setPojedinacnaGoveda([]);
        setDodajPojedinacnaGoveda(false);
        onDataCanBeSaved(true);
      }
      const getSearchGoveda=()=>{
        return (
          <Box display={'flex'} flexDirection={'column'} flex={1} overflowY={'auto'} className="noscroll">
            <GovedaListForSpecifikacija preselected={getPojedinacnaGovedaId}  onSelect={handlePojedinacnoGovedoSelected} goveda={pojedinacnagoveda} onSelectKnjiga={(knjid)=>setSelectedKnjigaId(knjid)} onFinishSelectGoveda={handleFinishSelectPojedinacnaGoveda} onClose={handleCloseSelectPojedinacnoGovedo} knjige={knjige}/>   
          </Box>
        )
      }
      const handleSpecifikacijaOdlaskaDataChange=(_d)=>{
        const _s={...specifikacija};
        _s.odlazakdetails.dokument_broj=_d.dokument_broj;
        _s.odlazakdetails.jibg=_d.jibg;
        _s.odlazakdetails.kamion_br=_d.kamion_br;
        _s.odlazakdetails.migracija_datum=_d.migracija_datum;
        _s.odlazakdetails.migracija_ijr=_d.migracija_ijr;
        _s.odlazakdetails.migracija_posjednik_id=_d.migracija_posjednik_id;
        _s.odlazakdetails.migrdok_tip_id=_d.migrdok_tip_id;
        _s.odlazakdetails.uktezina=_d.uktezina;
        _s.odlazakdetails.migracija_posjednik_drzava=_d.migracija_posjednik_drzava;
        _s.odlazakdetails.migracija_posjednik_mjesto=_d.migracija_posjednik_mjesto;
        _s.odlazakdetails.migracija_posjednik_naziv=_d.migracija_posjednik_naziv;
        _s.odlazakdetails.migracija_posjednik_sifra=_d.migracija_posjednik_sifra;
        _s.odlazakdetails.migracija_tip=_d.migracija_tip;
        _s.odlazakdetails.organizator_id=_d.organizator_id;
        onChange(_s);
        setSpecifikacija(_s);
        /*
id:id,kamion_br:kamion_br,migracija_datum:migracija_datum,migracija_ijr:migracija_ijr,migrdok_tip_id:migrdok_tip_id,dokument_broj:dokument_broj,
        migracija_posjednik_id:migracija_posjednik_id,jibg:jibg,uktezina:uktezina,migracija_tip:"",
        migracija_posjednik_naziv:"",migracija_posjednik_mjesto:"",migracija_posjednik_drzava:"",migracija_posjednik_sifra:""
        */
      }
      const showSpecifikacijaData=()=>{
        return (
          <Box display={'flex'} flexDirection={'column'} flex={1}>
            <Tabs align='start' variant='enclosed' size={'sm'} colorScheme={'grunt2'} display={'flex'} flexDirection={'column'} flex={1}>
              <TabList display={'flex'} flexDir={'row'} h={'2rem'}>
                <Tab _focus={{fontWeight:'bold'}}>Goveda</Tab>
                <Tab _focus={{fontWeight:'bold'}}>Detalji specifikacije</Tab>
              </TabList>
              <TabPanels display={'flex'} flexDir={'column'} flex={1}>
                <TabPanel  display={'flex'} flexDir={'column'} flex={1}>
                  {getMenu()}
                  {getSelectedGoveda()}
                </TabPanel>
                <TabPanel display={'flex'} flexDir={'column'} flex={1}>
                  {/* odlazakdetails:{
      specid:specifikacijaid,kamion_br:'',migracija_datum:'1900-1-1',migracija_ijr:'1900-1-1',migrdok_tip_id:1,dokument_broj:'',
      migracija_posjednik_id:-1,jibg:'',uktezina:0  */}
                  <SpecifikacijaOdlazakDetails organizatori={organizatori} readonly={readonly} id={specifikacijaid} kamion_br={specifikacija.odlazakdetails.kamion_br} migracija_datum={specifikacija.odlazakdetails.migracija_datum}
                  migracija_ijr={specifikacija.odlazakdetails.migracija_ijr} migrdok_tip_id={specifikacija.odlazakdetails.migrdok_tip_id} dokument_broj={specifikacija.odlazakdetails.dokument_broj}
                  migracija_posjednik_id={specifikacija.odlazakdetails.migracija_posjednik_id} jibg={specifikacija.odlazakdetails.jibg} uktezina={specifikacija.odlazakdetails.uktezina}
                  migracija_tip={specifikacija.odlazakdetails.migracija_tip} migracija_posjednik_naziv={specifikacija.odlazakdetails.migracija_posjednik_naziv}
                  migracija_posjednik_mjesto={specifikacija.odlazakdetails.migracija_posjednik_mjesto} migracija_posjednik_drzava={specifikacija.odlazakdetails.migracija_posjednik_drzava}
                  migracija_posjednik_sifra={specifikacija.odlazakdetails.migracija_posjednik_sifra} organizator_id={specifikacija.odlazakdetails.organizator_id}
                  onChange={handleSpecifikacijaOdlaskaDataChange}/>
                  {/* id:id,kamion_br:kamion_br,migracija_datum:migracija_datum,migracija_ijr:migracija_ijr,migrdok_tip_id:migrdok_tip_id,dokument_broj:dokument_broj,
        migracija_posjednik_id:migracija_posjednik_id,jibg:jibg,uktezina:uktezina,migracija_tip:"",
        migracija_posjednik_naziv:"",migracija_posjednik_mjesto:"",migracija_posjednik_drzava:"",migracija_posjednik_sifra:"" */}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        )
      }

      const buildScreen=()=>{
        if (!dataisloading && !dataknjigeisloading ) {
          if (dodajpopis) {
            return (
              showDodajPopis()
            )
          } else if (dodajpojedinacnagoveda) {
            return (
              getSearchGoveda()
            )
          }  else {
            return (
              
              showSpecifikacijaData()
            )
          }
        }
      }
      
    
    return (
        <Box display={'flex'} flexDirection={'column'} flex={1}>
             {getSkeleton()} 
            {showErr()}
            {/* {getMenu()} */}
            {buildScreen()}
            <Divider/>
        </Box>
    )
}